module.exports = __webpack_public_path__ + "static/img/bacon-agaric_256.b181b42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bacon-agaric_256.png
// module id = lW9o
// module chunks = 0